import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {Provider, useDispatch} from 'react-redux';
import store from './redux/store/store';

import {callGetGeoLocation, getDeviceId, getGeoLocation, init, onresize} from './services/functions';
import Spinner from './pages/Spinner';
import Alert from './components/Alert';
import Main from './Main';

const root = ReactDOM.createRoot(document.getElementById('root'));

// --- New Auto-Update Logic ---
const checkForUpdates = () => {
  console.log('Cordova,checkForUpdates');

  if (cordova.plugins && cordova.plugins.InAppUpdate) {
    console.log("Cordova, checking for Play Store updates...");
    
    cordova.plugins.InAppUpdate.getUpdateAvailability((result) => {
      // result will be 'UPDATE_AVAILABLE' if there is a newer version on Play Store
      console.log('Cordova,result',result);

      if (result === 'UPDATE_AVAILABLE') {
        console.log("Cordova, update found! Triggering immediate update.");
        
        // .updateImmediate() forces a full-screen update UI
        // .updateFlexible() allows the user to use the app while downloading in background

        cordova.plugins.InAppUpdate.updateImmediate(
          () => console.log("Update success"),
          (err) => console.error("Update failed", err)
        );
      } else {
        console.log("Cordova, app is up to date.");
      }
    }, (err) => {
      console.error("Cordova, update check failed", err);
    });
  }else{
    console.log("Cordova, else..");
  }
};

// Render React DOM
const renderReactDom = async () => {
  root.render(
  <Provider store={store}>
      <Main />
  </Provider>
);
  document.documentElement.classList.remove("booting"); // body goes back to normal
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", "#ffffff");

};

const registerServiceWorker = async () =>{
  console.log("Cordova,registerServiceWorker");
  if('serviceWorker' in navigator){
    console.log('Cordova,service worker is available')
    navigator.serviceWorker.register('/sw.js')
    .then(function(){
      console.log('Cordova,service worker registered')
    });
  }
}

const requestLocationPermission = async () => {
  if (cordova.plugins.diagnostic) {
    console.log("Cordova,Checking location permission...");

    // Check current location permission status
    // cordova.plugins.diagnostic.getLocationAuthorizationStatus((status) => {
    //   if (status === cordova.plugins.diagnostic.permissionStatus.GRANTED) {
    //     console.log("Location permission already granted.");
    //     callGetGeoLocation();
    //   } else if (status === cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED) {
    //     console.log("Requesting location permission...");
    //     cordova.plugins.diagnostic.requestLocationAuthorization(
    //       (newStatus) => {
    //         if (newStatus === cordova.plugins.diagnostic.permissionStatus.GRANTED) {
    //           console.log("Location permission granted.");
    //           callGetGeoLocation();
    //         } else {
    //           console.log("Location permission denied.");
    //         }
    //       },
    //       (error) => console.error("Permission request error:", error)
    //     );
    //   } else {
    //     console.log("Location permission denied.");
    //   }
    // }, (error) => console.error("Permission check error:", error));


    navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
      console.log("Cordova,Permission state:", result.state);
      if (result.state === 'granted') {
          callGetGeoLocation();
      } else if (result.state === 'prompt') {
          console.log("Cordova,User needs to be asked for location access.");
      } else {
          console.error("Cordova,Location permission denied.");
      }
    });
  }
};


// Cordova Initialization
const initCordova = () => {
  renderReactDom();

  document.addEventListener(
    'deviceready',
    () => {
      console.log('Cordova is ready');

      // 1. Check for Auto-Updates immediately
      checkForUpdates();

      // 2. Persist storage check
      if (!window.indexedDB) {
        console.log("IndexedDB is not supported in this environment.");
      } else {
        console.log("IndexedDB is supported.");
        navigator.storage.persist().then((isPersisted) => {
          console.log(isPersisted ? "Storage will persist" : "Storage may be cleared by the OS");
        });
      }

      if (window.cordova && /android/i.test(navigator.userAgent)) {
        document.documentElement.classList.add("android-app");
      }

      // Request location permission
      requestLocationPermission();
      // setTimeout(() => {
      //   navigator?.splashscreen?.hide();
      // }, 1000);
    },
    false
  );
};

// Main Initialization
if (window.cordova) {
  //navigator?.splashscreen?.show();
  console.log('Cordova, window.cordova',window.cordova);
  initCordova();
} else {
  callGetGeoLocation();
  renderReactDom()
} 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
init();
getDeviceId();